/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-08 23:43:44
 * @FilePath: /unifyxp-v2-store-portal/src/layout/Components/SiderVertical/tools.ts
 */
import { replace } from 'lodash';

export const getKeyPath = (key, menuArray, mem) => {
  let arr = mem || [];
  for (const i of menuArray) {
    if (i.key === key) {
      if (i.sub) {
        return [];
      } else {
        arr = [i.key, ...arr];
        return arr;
      }
    } else {
      if (i.sub) {
        arr = getKeyPath(key, i.sub, arr);
        if (arr.length > 0) {
          arr = [...arr, i.key];
          return arr;
        } else {
          continue;
        }
      } else {
        continue;
      }
    }
  }
  return [];
};
export const mapChildrenParent = (menuArray) => {
  return menuArray.reduce((pre, now) => {
    if (now.sub) {
      return {
        ...pre,
        [now.key]: now.sub.map((i) => ({ key: i.key, path: i.path })),
      };
    } else {
      return pre;
    }
  }, {});
};

export const mapRouters = (routers, key) => {
  return routers.reduce((pre, now) => {
    //    const reg = new RegExp('^' + now.replace('*/g', '[^/]+') + '$');

    const reg = new RegExp('^' + replace(now, /\*/g, '[^/]+') + '$');
    // console.log('1-1,' + now.replaceAll('*', '[^/]+'));
    // console.log('1-2,' + replace(now, /\*/g, '[^/]+'));
    return [...pre, { key, reg }];
  }, []);
};
export const mapMenuRouterKey = (menuArray, mem) => {
  //=>[路由:key]
  return menuArray.reduce((pre, now) => {
    if (now.sub) {
      const res = mapMenuRouterKey(now.sub || [], pre);
      return [...pre, ...res];
    } else {
      const res = mapRouters(now.routers, now.key) || {};

      return [...pre, ...res];
    }
  }, mem || []);
};
